export const ERROR_CODES = {
  EMAIL_EXISTS: 'email_exists',
  UNKNOWN_ERROR: 'unknown_error',
};
